import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  if (featured.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              编辑精选
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              不容错过的深度好文
            </h2>
          </div>
          <Link
            to="/category/qinggan-lianjie"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            浏览更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-8">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}